import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SvgImage } from '..';
import { translate } from '../../services';
import { Badge } from '@mui/material';

export const IconButton = ( { className, detailComponent, disabled, hidden, icon, onClick, text, tooltip, getWarningComponent, showMandatoryWarning } ) => {
  const componentClassName = classNames( className, {'icon-button':className!=="primary-button", 'disabled': disabled, 'hidden': hidden } );
  const textClassName = classNames( 'ellipsed', { 'hide-on-small': icon } );
  const classname = classNames("icon-button-icon", {"white-icon":className?.includes("icon-bg-black")})

  const onClickHandler = e => {
    if( disabled || hidden ) {
      return;
    }
    e.stopPropagation();
    onClick(e);
  };
  
  const showExclamation = getWarningComponent&&showMandatoryWarning?<span className="badge" style={{height:"16px", width:"16px"}}>!</span>:<></>;

  return <div className={ componentClassName } title={ hidden ? '' : tooltip } onMouseDown={ onClickHandler }>
    {getWarningComponent&&!hidden&&icon&&<Badge sx={{'& .MuiBadge-badge':{ left: "0px",
    top: "-4px",
    right: "0px", zIndex:0}}} badgeContent={getWarningComponent&&showMandatoryWarning&&<span className="badge" style={{height:"16px", width:"16px"}}>!</span>}>
    <SvgImage source={ icon } className={classname}/></Badge>}
    {detailComponent&&!hidden&&icon&&<Badge sx={{'& .MuiBadge-badge':{ left: "0px",
    top: "-4px",
    right: "0px", zIndex:0}}} badgeContent={detailComponent&&<span className="badge" style={{height:"16px", width:"16px"}}>{detailComponent}</span>}>
    <SvgImage source={ icon } className={classname}/></Badge>}
    { !hidden && icon && !getWarningComponent && !detailComponent && <SvgImage source={ icon } className={classname}/> }
    { !hidden && text && 
            <span>{text}</span>
         }
    {/* { !hidden && detailComponent } */}
  </div>;
};

IconButton.propTypes = {
  className: PropTypes.string, 
  detailComponent: PropTypes.node, 
  disabled: PropTypes.bool, 
  hidden: PropTypes.bool, 
  icon: PropTypes.string, 
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string, 
  tooltip: PropTypes.string
};